import api from './api';

const concesionariaAreaDespachoService = {
  getAreas(params = {}) {
    return api.get('/produccion-concesionaria/configuraciones/areas-despacho', { params }).then((r) => r.data);
  },
  createArea(data) {
    return api.post('/produccion-concesionaria/configuraciones/areas-despacho', data).then((r) => r.data);
  },
  updateArea(id, data) {
    return api.put(`/produccion-concesionaria/configuraciones/areas-despacho/${id}`, data).then((r) => r.data);
  },
  deleteArea(id) {
    return api.delete(`/produccion-concesionaria/configuraciones/areas-despacho/${id}`).then((r) => r.data);
  },
};

export default concesionariaAreaDespachoService;
